import {HttpClient} from "@angular/common/http";
import {Component, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {FormFieldContainer} from "../../models/infix-formula/formFieldContainer";
import {ServiceField} from "../../models/service-field";

@Injectable()
export class FormControllerService {

  private baseUrl: string = environment.BASE_URL + "service/";

  constructor(private http: HttpClient) {
  }

  public getSystemFields(): Observable<ServiceField[]> {
    return this.http.get(this.baseUrl + "systemfields") as Observable<ServiceField[]>;
  }

  public getServiceFields(serviceId: string, options: any): Observable<any[]> {
    return this.http.get(this.baseUrl + serviceId + "/fields?" + (new URLSearchParams(options).toString())) as Observable<any[]>;
  }
  public getServiceFieldsWithComponentHierarchy(serviceId: string): Observable<any[]> {
    return this.http.get(this.baseUrl + serviceId + "/fields?showFullTree=true") as Observable<any[]>;
  }

  public getServiceFieldsWithCVF(serviceId: string): Observable<any[]> {
    return this.http.get(this.baseUrl + serviceId + "/fields?showFullTree=true&showCvf=true") as Observable<any[]>;
  }

  public getFilteredFormFields(serviceId: string, filterByType: string, onlyEventComponents: boolean, showFullTree: boolean, addDeterminants: boolean, addSchemaProperty: boolean, addRegistrations: boolean, showTables: boolean, addButtons: boolean): Observable<any[]> {
    return this.http.get(this.baseUrl + serviceId + "/fields?onlyEventComponents=" + onlyEventComponents
      + (filterByType ? "&filterByType=" + filterByType : "") + (showFullTree ? "&showFullTree=true" : "")
      + (addDeterminants ? "&addDeterminants=true" : "")
      + (addSchemaProperty ? "&addSchemaProperty=true" : "")
      + (addRegistrations ? "&addRegistrations=true" : "")
      + (showTables ? "&showTables=true" : "")
      + (addButtons ? "&addButtons=true" : "")) as Observable<Component[]>;
  }

  public getEmailFields(serviceId: string): Observable<any[]> {
    return this.http.get(this.baseUrl + serviceId + "/fields?filterByType=email,textfield") as Observable<Component[]>;
  }

  public getPhoneFields(serviceId: string): Observable<any[]> {
    return this.http.get(this.baseUrl + serviceId + "/fields?filterByType=textfield") as Observable<Component[]>;
  }

  public getFieldsWithSchemas(serviceId: string): Observable<any[]> {
    return this.http.get(this.baseUrl + serviceId + "/fields?addSchemaProperty=true") as Observable<any[]>;
  }

  public getFlattenFormFields(serviceId: string, onlyEventComponents: boolean = false): Observable<any[]> {
    return this.http.get(this.baseUrl + serviceId + "/fields?onlyEventComponents=" + onlyEventComponents) as Observable<any[]>;
  }

  public getFlattenFormFieldsWithAdds(serviceId: string, onlyEventComponents: boolean = false, addActions: boolean = false, addDeterminants: boolean = false, addRegistrations: boolean = false, addCustomClasses: boolean = false, addButtons: boolean = false): Observable<any[]> {
    return this.http.get(this.baseUrl + serviceId + `/fields?onlyEventComponents=${onlyEventComponents}&addActions=${addActions}&addDeterminants=${addDeterminants}&addCustomClasses=${addCustomClasses}&addRegistrations=${addRegistrations}&addButtons=${addButtons}`) as Observable<any[]>;
  }

  public getFormField(serviceId: string, fieldKey: string): Observable<any[]> {
    return this.http.get(this.baseUrl + serviceId + "/fields/" + fieldKey) as Observable<Component[]>;
  }

  public getFormFieldContainer(serviceId: string, fieldKey: string): Observable<FormFieldContainer> {
    return this.http.get(this.baseUrl + serviceId + "/formfield/" + fieldKey + "/container") as Observable<FormFieldContainer>;
  }

  public getAllFormStatuses(serviceId: string): Observable<any> {
    return this.http.get(this.baseUrl + serviceId + "/formStatuses") as Observable<any>;
  }

  public deleteComponent(serviceId: string, componentKey: string) {
    return this.http.delete(this.baseUrl + serviceId + "/componentkey/" + componentKey, { responseType: "text" });
  }

  public downloadSchemaWithRelations(formId: string): Observable<any> {
    return this.http.get(environment.BASE_URL + "forms/" + formId + "/schema-with-relations", { responseType: "blob" });
  }
}
